var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkBox customCheckBox",class:{ checked: _vm.isChecked ,disable:_vm.isDisable},on:{"click":_vm.onCheckBoxChanged}},[_c('span',{staticClass:"customCheckBoxItem"}),_c('span',{staticClass:"customCheckBoxTitle"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }